module.exports = __webpack_public_path__ + "img/admin-capture-dashboard.a8b95d83.png";